import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../reducers";
import { bindActionCreators } from "redux";
import * as action from '../actions/flags';

type ActionDataOps = {
  action: {
    successMessage: string,
    errorMessage: string
  },
  actionSucceeded: boolean
}
type Flags = {
  actionDataOps?: ActionDataOps;
  scheduleFetch?:boolean;
  liveFetch?:boolean;
  dataOpsFetch?:boolean;
  practiceSaved?:boolean;
  download?:boolean;
  createAndGoFlag?: boolean;
  playsSavedFlag?: boolean;
  reprocessFlag?: boolean | string;
}
export const useFlagsState = () => {
  const flags = useSelector((state: RootState) => state.flags) as Flags;
  const actionSucceeded = flags && flags.actionDataOps ? flags.actionDataOps.actionSucceeded : null;
  const messageFromAction = actionSucceeded === null ? null :
    actionSucceeded === true ? flags?.actionDataOps?.action.successMessage :
    flags?.actionDataOps?.action.errorMessage;
  const practiceSaved = flags.practiceSaved ? flags.practiceSaved : false;
  const download = flags.download ? flags.download : false; 
  const createAndGoFlag = flags.createAndGoFlag? flags.createAndGoFlag : false;
  const playsSavedFlag = flags.playsSavedFlag? flags.playsSavedFlag : false;
  const reprocessFlag = flags.reprocessFlag? flags.reprocessFlag : false;
  return {
    messageFromAction,
    actionSucceeded,
    practiceSaved,
    download,
    createAndGoFlag,
    playsSavedFlag,
    reprocessFlag
  };
};

export const useFlagsDispatch = () => {
  const dispatch = useDispatch();
  return {
    ...bindActionCreators({ ...action }, dispatch),
    hideActionStartedMessage :() => {
      dispatch(action.changeActionSuccessFlag(null, null));
    }
  };
};
